/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15.994 3.006a5.7 5.7 0 0 0-3.795 1.707L12 4.916l-.199-.202a5.676 5.676 0 0 0-8.128 0c-2.231 2.275-2.231 5.953 0 8.228L12 21.428l8.326-8.486A5.873 5.873 0 0 0 22 8.828a5.873 5.873 0 0 0-1.675-4.115A5.693 5.693 0 0 0 16.262 3zM16.262 5c.988 0 1.936.4 2.636 1.114C19.603 6.832 20 7.81 20 8.828s-.397 1.996-1.101 2.713l-6.9 7.031-6.898-7.03a3.894 3.894 0 0 1 0-5.428 3.676 3.676 0 0 1 5.272 0L12 7.775l1.626-1.66A3.696 3.696 0 0 1 16.262 5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHeart as Heart };
